export function validateDate(date) {
  if (Object.prototype.toString.call(date) === "[object Date]")
    return !isNaN(date.getTime());
  else return false;
}

export function replaceArrayWithWebContent(results) {
  results.forEach(data => {
    if (!data.channels?.includes("web")) {
      return;
    }
    replaceWithWebContent(data);
    replaceWithWebContent(data.moment);
  });
}

export function replaceWithWebContent(data) {
  const web = data?.alternative_content?.web;
  if (!web) {
    return;
  }
  const webIterable = new Map(Object.entries(web));
  webIterable.forEach((val, fieldName) => {
    // f.e. data.description = web.description || data.description
    if (fieldName !== "_id")
      data[fieldName] = web[fieldName] || data[fieldName];
  });
}

export function getURLParamsObject(decodeValues) {
  const urlParams = new URLSearchParams(window.location.search);
  const obj = Object.fromEntries(urlParams);
  if (!Object.keys(obj)?.length) {
    return {};
  }
  if (decodeValues) {
    Object.keys(obj).forEach(k => (obj[k] = decodeURIComponent(obj[k])));
  }
  return obj;
}

export function appendCurrentParamsToURL(url) {
  let c = "?";
  let urlWithParams = url;
  const currentURLParams = getURLParamsObject(true);
  for (const [key, value] of Object.entries(currentURLParams)) {
    if (key.startsWith("tx_eoevents")) {
      continue;
    }
    urlWithParams += `${c}${key}=${encodeURIComponent(value)}`;
    c = "&";
  }
  return urlWithParams;
}
